import styled from "styled-components";

export const WrapperContent = styled.div`
  padding: ${({ padding }) => (padding ? padding : "8px 20px")};
  margin: ${({ margin }) => (margin ? margin : "0 0 24px")};
`;
